import * as React from 'react';
import {
  Box,
  Select,
  MenuItem,
  Typography,
  InputLabel
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import {
  FilterContainer,
  FilterFormControl,
  FilterTextField,
  FilterButton,
  FilterButtonOutlined
} from '../style';
import { STATUS_OPTIONS, ONBOARDING_TYPE_OPTIONS } from '../constants';

interface RequestsFilterProps {
  localFilters: {
    status: string;
    onboardingType: string;
    requestNumber: string;
    raisedBy: string;
    raisedFor: string;
  };
  totalCount: number;
  onFilterChange: (filterName: string, value: string) => void;
  onApplyFilters: () => void;
  onClearFilters: () => void;
}

export default function RequestsFilter({
  localFilters,
  totalCount,
  onFilterChange,
  onApplyFilters,
  onClearFilters
}: RequestsFilterProps) {
  return (
    <FilterContainer>
      <FilterFormControl size="small">
        <InputLabel>Status</InputLabel>
        <Select
          value={localFilters.status}
          label="Status"
          onChange={(e) => onFilterChange('status', e.target.value)}
        >
          {STATUS_OPTIONS.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FilterFormControl>

      <FilterFormControl size="small" sx={{ minWidth: 200 }}>
        <InputLabel>Onboarding Type</InputLabel>
        <Select
          value={localFilters.onboardingType}
          label="Onboarding Type"
          onChange={(e) => onFilterChange('onboardingType', e.target.value)}
        >
          {ONBOARDING_TYPE_OPTIONS.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FilterFormControl>

      <FilterTextField
        size="small"
        label="Request Number"
        value={localFilters.requestNumber}
        onChange={(e) => onFilterChange('requestNumber', e.target.value)}
        sx={{ maxWidth: 150 }}
      />

      <FilterTextField
        size="small"
        label="Raised By"
        value={localFilters.raisedBy}
        onChange={(e) => onFilterChange('raisedBy', e.target.value)}
        sx={{ maxWidth: 150 }}
      />

      <FilterTextField
        size="small"
        label="Raised For"
        value={localFilters.raisedFor}
        onChange={(e) => onFilterChange('raisedFor', e.target.value)}
        sx={{ maxWidth: 150 }}
      />

      <FilterButton
        variant="contained"
        onClick={onApplyFilters}
      >
        Apply Filters
      </FilterButton>

      <FilterButtonOutlined
        variant="outlined"
        startIcon={<ClearIcon />}
        onClick={onClearFilters}
      >
        Clear
      </FilterButtonOutlined>

      <Box sx={{ flexGrow: 1 }} />

      <Typography variant="body2" sx={{ alignSelf: 'center' }}>
        Total: {totalCount} requests
      </Typography>
    </FilterContainer>
  );
}
